import React from 'react';
import Card from '../components/Card';
import { CreditCard, DollarSign, Ban as Bank } from 'lucide-react';

export default function Wallet() {
    return (
        <div className="space-y-6">
            <h1 className="text-2xl font-bold text-gray-900">Wallet</h1>

            <div className="grid md:grid-cols-3 gap-6">
                <Card className="bg-gradient-to-br from-[#001f3f] to-navy-700">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-200">Balance</p>
                            <h3 className="text-3xl font-bold text-white mt-1">$2,458.30</h3>
                        </div>
                        <DollarSign size={32} className="text-white opacity-80" />
                    </div>
                </Card>

                <Card>
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-600">Account Number</p>
                            <h3 className="text-xl font-semibold mt-1">****-4589</h3>
                        </div>
                        <Bank size={24} className="text-gray-400" />
                    </div>
                </Card>

                <Card>
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-600">Currency</p>
                            <h3 className="text-xl font-semibold mt-1">USD</h3>
                        </div>
                        <CreditCard size={24} className="text-gray-400" />
                    </div>
                </Card>
            </div>

            <Card title="Recent Transactions">
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead>
                        <tr className="text-left border-b border-gray-200">
                            <th className="pb-3 font-semibold text-gray-600">Date</th>
                            <th className="pb-3 font-semibold text-gray-600">Description</th>
                            <th className="pb-3 font-semibold text-gray-600">Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                        {[
                            { date: '2024-03-10', description: 'Deposit', amount: '+$500.00' },
                            { date: '2024-03-09', description: 'Withdrawal', amount: '-$200.00' },
                            { date: '2024-03-08', description: 'Reward Bonus', amount: '+$50.00' },
                        ].map((tx, i) => (
                            <tr key={i} className="border-b border-gray-100">
                                <td className="py-3 text-gray-600">{tx.date}</td>
                                <td className="py-3 text-gray-900">{tx.description}</td>
                                <td className={`py-3 ${tx.amount.startsWith('+') ? 'text-green-600' : 'text-red-600'}`}>
                                    {tx.amount}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </Card>
        </div>
    );
}